import React from 'react';
import classNames from 'classnames/bind';
import { Link } from 'react-router-dom';
import { SearchBlack } from '../../../../components/Icons/Icons';
import { Button } from '../../../../components';
import styles from './Filter.module.css'

const cx = classNames.bind(styles)
const Filter = ({ status, onChangeName }) => {
  const handleClick = () => {
    return 0;
  }
  const handleChangeName = (e) => {
    onChangeName(e.target.value)
  }
  return (
    <div className={cx("filter")}>
      <div className={cx("search")}>
        <input
          className={cx("search-input")}
          placeholder="Tìm kiếm..."
          onChange={handleChangeName}
          maxLength={155}
        />
        <span className={cx("icon-search")}>
          <SearchBlack />
        </span>
      </div>
      {status !== 403 && (
        <div >
          <Link
            to="/admin/role/add_role"
            style={{ textDecoration: "none", }}
          >
            <Button onClick={handleClick} className={cx("btn")} title="Thêm mới" />
          </Link>
        </div>
      )}
    </div>
  );
};

export default Filter;